import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';


import './footer.css';



const FooterNavbar = ({ onLogout }) => {
  const [showMore, setShowMore] = useState(false);

  const toggleMore = () => setShowMore(prev => !prev);

  return (
    <nav className="bottom-navbar">
      <NavLink to="/panelTienda" className="nav-item">
        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z" />
        </svg>
        <span>Cuenta</span>
      </NavLink>

      <button className="nav-item" onClick={toggleMore}>
        <svg width="24" height="24" fill="currentColor">
          <circle cx="12" cy="12" r="2" />
          <circle cx="19" cy="12" r="2" />
          <circle cx="5" cy="12" r="2" />
        </svg>
        <span>Más</span>
      </button>

      {showMore && (
        <div className="submenu">
          <NavLink to="/inicio" className="submenu-item">Administración</NavLink>
          <NavLink to="/panelCifras" className="submenu-item">Panel</NavLink>
          
          <div className="submenu-separator"></div>

          <button onClick={onLogout} className="submenu-item logout-button">
            Salir
          </button>
        </div>

      )}
    </nav>
  );
};

export default FooterNavbar;
